module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline",
    class: {
      'mobile': _vm.$mobile
    }
  }, [_c('div', {
    staticClass: "border"
  }), _vm._v(" "), _c('div', {
    staticClass: "episode-list"
  }, [_c('v-touch', {
    staticClass: "copy-01 episodes",
    attrs: {
      "tag": "ul"
    },
    on: {
      "swipeleft": _vm.slideRight,
      "swiperight": _vm.slideLeft
    }
  }, _vm._l((_vm.episodes), function(episode, index) {
    return _c('li', {
      staticClass: "episode",
      class: {
        'locked': episode.locked, 'active': index === _vm.$store.state.game.episode || _vm.$store.state.debugmode, 'complete': _vm.$store.state.game.episodes[index].answers.length === _vm.$store.state.game.episodes[index].actions.length
      },
      style: ({
        width: _vm.width()
      }),
      on: {
        "click": function($event) {
          _vm.startEpisode(index)
        }
      }
    }, [_c('h4', [_vm._v(_vm._s(episode.title))]), _vm._v(" "), _c('div', {
      staticClass: "thumbnail-container",
      class: {
        'mobile': _vm.$mobile
      }
    }, [_c('img', {
      staticClass: "thumbnail",
      attrs: {
        "src": episode.thumbnail
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "state"
    })])])
  })), _vm._v(" "), (!_vm.$mobile) ? _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "arrow-left nav-arrow",
    class: {
      'hidden': _vm.activeEp == 0
    },
    on: {
      "click": function($event) {
        _vm.slideLeft()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow-right nav-arrow",
    class: {
      'hidden': _vm.activeEp == _vm.episodes.length - 1
    },
    on: {
      "click": function($event) {
        _vm.slideRight()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "pagination"
  }, _vm._l((_vm.episodes), function(episode, index) {
    return _c('li', {
      staticClass: "pagination-bullet",
      class: {
        'locked': episode.locked, 'active': index === _vm.$store.state.game.episode, 'complete': _vm.$store.state.game.episodes[index].answers.length === _vm.$store.state.game.episodes[index].actions.length, 'mobile': _vm.$mobile
      }
    })
  }))], 1), _vm._v(" "), (!_vm.$mobile) ? _c('div', {
    staticClass: "points-container"
  }, [_c('span', [_vm._v(" Totaal aantal punten: ")]), _vm._v(_vm._s(_vm.points) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-97bdae1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Timeline.vue
// module id = 124
// module chunks = 1